import React from "react"
import { Slide, Snackbar } from "@material-ui/core"
import useMediaQuery from "@material-ui/core/useMediaQuery"

import SnackbarContentWrapper from "molecules/SnackbarContentWrapper"
import useSnackbar from "hooks/useSnackbar"

const TransitionLeft = props => {
  return <Slide {...props} direction="left" />
}

const TransitionUp = props => {
  return <Slide {...props} direction="up" />
}

const SnackbarWrapper = () => {
  const { snackbar, closeSnackbar } = useSnackbar()
  const handleClose = () => {
    closeSnackbar()
  }
  const isTabletPC = useMediaQuery("(min-width:600px)")
  const anchorPosition = isTabletPC
    ? {
        vertical: "top",
        horizontal: "right",
      }
    : {
        vertical: "bottom",
        horizontal: "center",
      }
  const transition = isTabletPC ? TransitionLeft : TransitionUp
  return (
    <Snackbar
      id="snackbar"
      anchorOrigin={anchorPosition}
      open={snackbar.isOpen}
      autoHideDuration={3200}
      onClose={handleClose}
      TransitionComponent={transition}
    >
      <SnackbarContentWrapper
        variant={snackbar.variant}
        message={snackbar.message}
        onClose={handleClose}
      />
    </Snackbar>
  )
}

export default SnackbarWrapper
